import { useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { upperFirst } from 'lodash-es';
import {
  setPagePropertiesFromData,
  setDeviceDataFromHeaders,
  trackAmplitudeEvent,
  AmplitudeEvent,
} from '@/lib/analyticsHelper';
import { ScreenName, ScreenTemplate, TealiumSlot } from '@/constants';
import { usePageAttributes } from '../contexts/PageAttributesContext';

const NoResults = () => {
  const { seoPageId, serviceIdForMember, deviceChar, pageType } = usePageAttributes();

  useEffect(() => {
    const pageProperties = {
      screen_name: ScreenName.SEGMENTATION,
      screen_template: ScreenTemplate.SEGMENTATION,
      seo_page_id: Number(seoPageId),
      service_id_for_member: serviceIdForMember,
      slots: TealiumSlot.VISITOR,
    };
    if (deviceChar && Object.keys(deviceChar).length > 0) {
      setPagePropertiesFromData(pageProperties);
      setDeviceDataFromHeaders(deviceChar);
    }

    const errorViewedData = {
      seo_page_type: upperFirst(pageType?.toLowerCase()),
      error_description: 'SEO no results',
      service_id_for_member: serviceIdForMember,
    };

    trackAmplitudeEvent(AmplitudeEvent.errorViewed, errorViewedData);
  }, [deviceChar, pageType, seoPageId, serviceIdForMember]);

  return (
    <Grid item xs={12}>
      <Box pb={4}>
        <Box mb={1}>
          <Typography variant="h2" component="h3" color="primary">
            Sorry!
          </Typography>
        </Box>
        <Typography variant="body3" color="primary">
          There are no results in this category near your location. Please try searching for another
          category of results or changing your location.
        </Typography>
      </Box>
    </Grid>
  );
};

export default NoResults;
